var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "$lightgray3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2901 22.88L20.1701 19L16.2901 15.12C16.1975 15.0274 16.124 14.9175 16.0739 14.7965C16.0238 14.6756 15.998 14.5459 15.998 14.415C15.998 14.2841 16.0238 14.1544 16.0739 14.0334C16.124 13.9125 16.1975 13.8026 16.2901 13.71C16.3826 13.6174 16.4926 13.544 16.6135 13.4939C16.7345 13.4438 16.8641 13.418 16.9951 13.418C17.126 13.418 17.2556 13.4438 17.3766 13.4939C17.4976 13.544 17.6075 13.6174 17.7001 13.71L22.2901 18.3C22.6801 18.69 22.6801 19.32 22.2901 19.71L17.7001 24.3C17.6076 24.3927 17.4977 24.4662 17.3767 24.5164C17.2557 24.5666 17.126 24.5924 16.9951 24.5924C16.8641 24.5924 16.7344 24.5666 16.6134 24.5164C16.4925 24.4662 16.3826 24.3927 16.2901 24.3C15.9101 23.91 15.9001 23.27 16.2901 22.88Z",
    fill: "#242525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSide);
export default __webpack_public_path__ + "static/media/openSide.c2ce19b76550e3b3b70dc0fd576f0984.svg";
export { ForwardRef as ReactComponent };